<button
  type="button"
  [class]="buttonClass()"
  [disabled]="estaDesabilitado()"
  (click)="handleClick.emit($event)"
>
  @if (loading()) {
    <i class="pi pi-spin pi-spinner text-[10px]" aria-hidden="true"></i>
  }
  {{ label() }}
</button>
